export enum InactivityType {
  Continue, //They choose to continue the course
  AutoLogout, //They get timed out and autologout occurs
  Logout, //They choose to logout
  ExitCourse, //They choose to exit the course
  AutoExitCourse //They get timed out and an exit course occurs
}
